import { FC, ReactNode } from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const Modal: FC<{
  title: string|ReactNode,
  children: ReactNode,
  statusIcon?: ReactNode,
  onClose?: () => void,
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false,
  compactHeader?: boolean,
  open?: boolean,
  footer?: ReactNode,
}> = ({
  title,
  children,
  statusIcon,
  onClose = () => null,
  maxWidth = 'md',
  compactHeader = false,
  open = true,
  footer,
}) => (
  <Dialog
    open={open}
    onClose={() => {
      onClose();
    }}
    maxWidth={maxWidth}
    fullWidth
  >
    <div className="align-status">
      <div className="left">
        <DialogTitle>{title}</DialogTitle>
      </div>
      <Box display="flex" gap={1}>
        {statusIcon}
        <IconButton sx={{ marginRight: '15px' }} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
    </div>

    <DialogContent sx={compactHeader ? { pt: 0.2 } : undefined}>
      {children}
    </DialogContent>

    {footer && (
    <DialogActions>
      {footer}
    </DialogActions>
    )}

  </Dialog>
);
